import type { FormatterType } from "@ext/markdown/core/edit/logic/Formatter/Formatters/typeFormats/getFormatterType";
import type { NodeSerializerSpec } from "@ext/markdown/core/edit/logic/Prosemirror/to_markdown";
import type TabAttrs from "@ext/markdown/elements/tabs/model/TabAttrs";

const TabsFormatter =
	(formatter: FormatterType): NodeSerializerSpec =>
	async (state, node) => {
		const childAttrs: TabAttrs[] = node.attrs.childAttrs;
		node.forEach((tab, _, idx) => {
			const attrs = childAttrs[idx];
			if (!attrs) return;
			// biome-ignore lint/suspicious/noExplicitAny: i know it's a hack
			(tab.attrs as any) = { ...attrs, property: tab.attrs.property };
		});
		await state.wrapContainer(
			formatter.openTag("tabs"),
			formatter.closeTag("tabs"),
			node,
			async () => await state.renderStructuralChildren(node),
			formatter.indentsContainers,
		);
	};

export default TabsFormatter;
